export default __webpack_public_path__ + "static/media/(89).cbcacdf4.jpg";